import { combineReducers, Action, Reducer } from 'redux';

import * as reducers from './ducks';

export default () =>
  combineReducers({
    ...reducers,
  });
